module.exports = __webpack_public_path__ + "static/media/express.2fbabc78.svg";